import { Model } from '@app/models/model';
import { User } from '@app/models/users/users.model';
import { Location } from '@app/models/locations/locations.model';

export class Device extends Model {
    // Backend fields
    id: string;
    type: number;
    description?: string;
    connected: boolean;
    last_seen: string;
    location_id: number;
    user_id: number;
    bridge_id?: string;
    product?: string;

    // Frontend fields
    location?: Location;
    user?: User;
    overallStatus?: string;
    waterUse?: Array<{ datetime?: string; value: number }>;
    totalWaterUse?: number;
    avgWaterUse?: number;
    highestWaterDate?: string;
    highestWaterUse?: number;

    calculateOverallStatus() {
        if (this.location) {
            if (this.location.status === 'Active' && !this.connected) {
                this.overallStatus = 'Offline';
            } else {
                this.overallStatus = this.location.status;
            }
        }
    }
}
